export default {
  complexDetailsData: null,
  complexPropertiesData: [],
  complexPropertiesTotalData: 0,
  photosData: [],
  videoData: [],
  planData: [],
}